import { useState, useRef } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

const DONUT_THUMB = "/donuts/donut_play.png?v=3";

export const StoryVideo = () => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const playVideo = () => {
    setPlaying(true);
    videoRef.current?.play();
  };

  return (
    <div className="w-full">
      <div className="relative rounded-3xl overflow-hidden shadow-2xl ring-4 ring-white/60 aspect-video bg-black">
      <video
        ref={videoRef}
        data-testid="mission-video"
        src="https://customer-assets.emergentagent.com/job_bobo-donuts-hub/artifacts/l6e57tul_4DAC371E-352A-43E1-9EF4-492A23904B6E.mov"
        controls={playing}
        playsInline
        preload="metadata"
        onPause={() => setPlaying(false)}
        onPlay={() => setPlaying(true)}
        className="absolute inset-0 w-full h-full object-contain block"
      />
      {!playing && (
        <div className="absolute inset-0 bg-gradient-to-br from-[#f7f0eb] via-[#fbe4ea] to-[#f9d6df]">
          <span className="pointer-events-none absolute top-10 left-[14%] w-3 h-3 rounded-full bg-[#ed4a76]/50 rotate-45" />
          <span className="pointer-events-none absolute bottom-12 right-[16%] w-3 h-3 rounded-full bg-[#111111]/15" />
          <span className="pointer-events-none absolute top-1/2 left-[8%] w-2.5 h-2.5 rounded-full bg-white/70 rotate-12" />
          <span className="pointer-events-none absolute bottom-10 left-[30%] w-2.5 h-2.5 rounded-full bg-[#ed4a76]/40" />
          <button
            data-testid="video-play-btn"
            onClick={playVideo}
            aria-label="Play Bobo's story"
            className="group absolute inset-0 grid place-items-center focus:outline-none"
          >
            <motion.div
              animate={{ y: [0, -10, 0] }}
              transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
              className="relative w-[34%] min-w-[150px]"
            >
              <img
                src={DONUT_THUMB}
                alt="Watch Bobo's story"
                className="w-full h-auto select-none drop-shadow-[0_7px_6px_rgba(17,17,17,0.28)] transition-transform duration-300 group-hover:scale-105 group-hover:-rotate-3"
              />
              <span
                className="absolute grid place-items-center w-[16%] h-[16%] transition-transform duration-300 group-hover:scale-125"
                style={{ left: "48.6%", top: "49.1%", transform: "translate(-50%, -50%)" }}
              >
                <Play className="w-full h-full text-[#ff648b] fill-[#ff648b] translate-x-[8%]" />
              </span>
            </motion.div>
          </button>
        </div>
      )}
      </div>
      {!playing && (
        <p
          data-testid="video-caption"
          className="mt-5 text-center font-display font-bold text-[#111111]/70 text-lg tracking-wide"
        >
          Press play — watch Bobo's story
        </p>
      )}
    </div>
  );
};
